<nz-spin [nzSpinning]="loading">
  <form nz-form [formGroup]="form" (ngSubmit)="submitForm()">
    <nz-row>
      <nz-col [nzFlex]="3" class="avatar-container">
        @if (!isAvatarValue()) {
          <nz-avatar [nzSize]="160" nzIcon="user"></nz-avatar>
        }
        @if (isAvatarValue()) {
          <app-avatar
            [sizePx]="160"
            [fullName]="{ firstName: form.get('firstName').value, lastName: form.get('lastName').value }"
          ></app-avatar>
        }
        <app-login-qr-code
          [badgeSvg]="rawBadgeSvg"
          [userLabel]="userLabel"
          [documentKey]="editObject?.documentKey || null"
        ></app-login-qr-code>
      </nz-col>
      <nz-col [nzFlex]="8">
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="login" nzRequired nzTooltipTitle="Wie sollen sich andere anmelden?">
            <span>Benutzername</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie Ihren Benutzernamen ein!">
            <input nz-input id="login" formControlName="login" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="firstName" nzRequired>
            <span>Vorname</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie Ihren Vornamen ein!">
            <input nz-input id="firstName" formControlName="firstName" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="lastName" nzRequired>
            <span>Nachname</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie Ihren Nachnamen ein!">
            <input nz-input id="lastName" formControlName="lastName" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="email">E-Mail</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Die Eingabe ist keine gültige E-Mail-Adresse!">
            <input nz-input formControlName="email" id="email" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="phone">Tel.</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <input nz-input formControlName="phone" id="phone" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="role" nzRequired>Rolle</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            {{form.controls.role.value | roleLabel}}
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="position" nzRequired>
            <span>Berufsbezeichnung</span>
          </nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Bitte geben Sie Ihre Berufsbezeichnung ein!">
            <input nz-input id="position" formControlName="position" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="multifactor">Zwei-Faktor-Authentifizierung</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            @if (form.controls.twoFactorAuthEnabled.value) {
              <button type="button" nz-button nzType="default" (click)="twoFactorAuthenticationComponent.showModal(form.controls.id.value, true)">Ausschalten</button>
            }
            @if (!form.controls.twoFactorAuthEnabled.value) {
              <button type="button" nz-button nzType="default" (click)="twoFactorAuthenticationComponent.showModal(form.controls.id.value, false)">Einschalten</button>
            }
          </nz-form-control>
        </nz-form-item>
      </nz-col>
    </nz-row>
  </form>
</nz-spin>

<app-two-factor-authentication #twoFactorAuthenticationComponent (currentStatusChanged)="form.controls.twoFactorAuthEnabled.patchValue($event)"></app-two-factor-authentication>
